// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { Array, ArrayT } from "./array";
import { Bool, BoolT } from "./bool";
import { Byte, ByteT } from "./byte";
import { ByteString, ByteStringT } from "./byte-string";
import { DateTime, DateTimeT } from "./date-time";
import { Double, DoubleT } from "./double";
import { ExpandedNodeIdValue, ExpandedNodeIdValueT } from "./expanded-node-id-value";
import { Float, FloatT } from "./float";
import { Guid, GuidT } from "./guid";
import { I16, I16T } from "./i16";
import { I32, I32T } from "./i32";
import { I64, I64T } from "./i64";
import { LocalizedText, LocalizedTextT } from "./localized-text";
import { NodeIdValue, NodeIdValueT } from "./node-id-value";
import { QualifiedNameValue, QualifiedNameValueT } from "./qualified-name-value";
import { SByte, SByteT } from "./sbyte";
import { StatusCodeValue, StatusCodeValueT } from "./status-code-value";
import { String, StringT } from "./string";
import { U16, U16T } from "./u16";
import { U32, U32T } from "./u32";
import { U64, U64T } from "./u64";
import { XmlElement, XmlElementT } from "./xml-element";

/**
 * A typed OPC UA value (a Variant scalar, structured value, or array).
 */
export enum Data {
  NONE = 0,
  Bool = 1,
  SByte = 2,
  Byte = 3,
  U16 = 4,
  I16 = 5,
  U32 = 6,
  I32 = 7,
  U64 = 8,
  I64 = 9,
  Float = 10,
  Double = 11,
  String = 12,
  DateTime = 13,
  Guid = 14,
  ByteString = 15,
  StatusCodeValue = 16,
  LocalizedText = 17,
  QualifiedNameValue = 18,
  NodeIdValue = 19,
  ExpandedNodeIdValue = 20,
  XmlElement = 21,
  Array = 22,
}

export function unionToData(
  type: Data,
  accessor: (
    obj:
      | Array
      | Bool
      | Byte
      | ByteString
      | DateTime
      | Double
      | ExpandedNodeIdValue
      | Float
      | Guid
      | I16
      | I32
      | I64
      | LocalizedText
      | NodeIdValue
      | QualifiedNameValue
      | SByte
      | StatusCodeValue
      | String
      | U16
      | U32
      | U64
      | XmlElement,
  ) =>
    | Array
    | Bool
    | Byte
    | ByteString
    | DateTime
    | Double
    | ExpandedNodeIdValue
    | Float
    | Guid
    | I16
    | I32
    | I64
    | LocalizedText
    | NodeIdValue
    | QualifiedNameValue
    | SByte
    | StatusCodeValue
    | String
    | U16
    | U32
    | U64
    | XmlElement
    | null,
):
  | Array
  | Bool
  | Byte
  | ByteString
  | DateTime
  | Double
  | ExpandedNodeIdValue
  | Float
  | Guid
  | I16
  | I32
  | I64
  | LocalizedText
  | NodeIdValue
  | QualifiedNameValue
  | SByte
  | StatusCodeValue
  | String
  | U16
  | U32
  | U64
  | XmlElement
  | null {
  switch (Data[type]) {
    case "NONE":
      return null;
    case "Bool":
      return accessor(new Bool())! as Bool;
    case "SByte":
      return accessor(new SByte())! as SByte;
    case "Byte":
      return accessor(new Byte())! as Byte;
    case "U16":
      return accessor(new U16())! as U16;
    case "I16":
      return accessor(new I16())! as I16;
    case "U32":
      return accessor(new U32())! as U32;
    case "I32":
      return accessor(new I32())! as I32;
    case "U64":
      return accessor(new U64())! as U64;
    case "I64":
      return accessor(new I64())! as I64;
    case "Float":
      return accessor(new Float())! as Float;
    case "Double":
      return accessor(new Double())! as Double;
    case "String":
      return accessor(new String())! as String;
    case "DateTime":
      return accessor(new DateTime())! as DateTime;
    case "Guid":
      return accessor(new Guid())! as Guid;
    case "ByteString":
      return accessor(new ByteString())! as ByteString;
    case "StatusCodeValue":
      return accessor(new StatusCodeValue())! as StatusCodeValue;
    case "LocalizedText":
      return accessor(new LocalizedText())! as LocalizedText;
    case "QualifiedNameValue":
      return accessor(new QualifiedNameValue())! as QualifiedNameValue;
    case "NodeIdValue":
      return accessor(new NodeIdValue())! as NodeIdValue;
    case "ExpandedNodeIdValue":
      return accessor(new ExpandedNodeIdValue())! as ExpandedNodeIdValue;
    case "XmlElement":
      return accessor(new XmlElement())! as XmlElement;
    case "Array":
      return accessor(new Array())! as Array;
    default:
      return null;
  }
}

export function unionListToData(
  type: Data,
  accessor: (
    index: number,
    obj:
      | Array
      | Bool
      | Byte
      | ByteString
      | DateTime
      | Double
      | ExpandedNodeIdValue
      | Float
      | Guid
      | I16
      | I32
      | I64
      | LocalizedText
      | NodeIdValue
      | QualifiedNameValue
      | SByte
      | StatusCodeValue
      | String
      | U16
      | U32
      | U64
      | XmlElement,
  ) =>
    | Array
    | Bool
    | Byte
    | ByteString
    | DateTime
    | Double
    | ExpandedNodeIdValue
    | Float
    | Guid
    | I16
    | I32
    | I64
    | LocalizedText
    | NodeIdValue
    | QualifiedNameValue
    | SByte
    | StatusCodeValue
    | String
    | U16
    | U32
    | U64
    | XmlElement
    | null,
  index: number,
):
  | Array
  | Bool
  | Byte
  | ByteString
  | DateTime
  | Double
  | ExpandedNodeIdValue
  | Float
  | Guid
  | I16
  | I32
  | I64
  | LocalizedText
  | NodeIdValue
  | QualifiedNameValue
  | SByte
  | StatusCodeValue
  | String
  | U16
  | U32
  | U64
  | XmlElement
  | null {
  switch (Data[type]) {
    case "NONE":
      return null;
    case "Bool":
      return accessor(index, new Bool())! as Bool;
    case "SByte":
      return accessor(index, new SByte())! as SByte;
    case "Byte":
      return accessor(index, new Byte())! as Byte;
    case "U16":
      return accessor(index, new U16())! as U16;
    case "I16":
      return accessor(index, new I16())! as I16;
    case "U32":
      return accessor(index, new U32())! as U32;
    case "I32":
      return accessor(index, new I32())! as I32;
    case "U64":
      return accessor(index, new U64())! as U64;
    case "I64":
      return accessor(index, new I64())! as I64;
    case "Float":
      return accessor(index, new Float())! as Float;
    case "Double":
      return accessor(index, new Double())! as Double;
    case "String":
      return accessor(index, new String())! as String;
    case "DateTime":
      return accessor(index, new DateTime())! as DateTime;
    case "Guid":
      return accessor(index, new Guid())! as Guid;
    case "ByteString":
      return accessor(index, new ByteString())! as ByteString;
    case "StatusCodeValue":
      return accessor(index, new StatusCodeValue())! as StatusCodeValue;
    case "LocalizedText":
      return accessor(index, new LocalizedText())! as LocalizedText;
    case "QualifiedNameValue":
      return accessor(index, new QualifiedNameValue())! as QualifiedNameValue;
    case "NodeIdValue":
      return accessor(index, new NodeIdValue())! as NodeIdValue;
    case "ExpandedNodeIdValue":
      return accessor(index, new ExpandedNodeIdValue())! as ExpandedNodeIdValue;
    case "XmlElement":
      return accessor(index, new XmlElement())! as XmlElement;
    case "Array":
      return accessor(index, new Array())! as Array;
    default:
      return null;
  }
}

export type DataT =
  | { type: "NONE"; value: null }
  | { type: "Bool"; value: BoolT }
  | { type: "SByte"; value: SByteT }
  | { type: "Byte"; value: ByteT }
  | { type: "U16"; value: U16T }
  | { type: "I16"; value: I16T }
  | { type: "U32"; value: U32T }
  | { type: "I32"; value: I32T }
  | { type: "U64"; value: U64T }
  | { type: "I64"; value: I64T }
  | { type: "Float"; value: FloatT }
  | { type: "Double"; value: DoubleT }
  | { type: "String"; value: StringT }
  | { type: "DateTime"; value: DateTimeT }
  | { type: "Guid"; value: GuidT }
  | { type: "ByteString"; value: ByteStringT }
  | { type: "StatusCodeValue"; value: StatusCodeValueT }
  | { type: "LocalizedText"; value: LocalizedTextT }
  | { type: "QualifiedNameValue"; value: QualifiedNameValueT }
  | { type: "NodeIdValue"; value: NodeIdValueT }
  | { type: "ExpandedNodeIdValue"; value: ExpandedNodeIdValueT }
  | { type: "XmlElement"; value: XmlElementT }
  | { type: "Array"; value: ArrayT };
